import template from './index.html'
import Base from '../../core/base'
import Input from './base'
export default {
  name: 'input',
  init: Base.createViewModel(Input),
  template
}



// WEBPACK FOOTER //
// ./src/components/input/index.js